import { NewsletterSubscription } from '../common/models/newsletters/newsletter-subscription.model';
import { VueLogger } from 'vue-logger-plugin/dist/types/logger';
import { FetchService } from './fetch.service';
import { beliefnetNewsletterSubscriptionsUrl } from './global-api.constants';
import { buildSubscribeRequestBody } from './newsletter-api.util';
import { resolveToNewsletterKey } from './newsletter-key-map';

export class NewslettersService {
    private logger: VueLogger;
    private fetchService: FetchService;

    constructor(logger: VueLogger, fetchService: FetchService) {
        this.logger = logger;
        this.fetchService = fetchService;
    }

    /**
     * Subscribe user to newsletters via Umbraco Global API v2.
     */
    async subscribe(subscription: NewsletterSubscription): Promise<boolean> {
        this.logger.debug('Posting subscription request to Umbraco newsletters API');
        try {
            const body = buildSubscribeRequestBody(subscription.newsletter.map(resolveToNewsletterKey), {
                partners: subscription.partners,
                rsid: subscription.rsid?.trim() || undefined,
                source: subscription.sourceDesc || undefined,
                firstName: subscription.name?.trim() || undefined
            });
            if (!body) {
                return false;
            }

            const url = beliefnetNewsletterSubscriptionsUrl(subscription.email);
            const result = await this.fetchService.post<unknown>(url, body, 'application/json');
            return result.ok;
        } catch (error) {
            this.logger.error('newsletter subscription failed: ', error);
        }

        return false;
    }
}
